import React from 'react';

export const TextInput = React.forwardRef(
  (
    props: React.InputHTMLAttributes<HTMLInputElement>,
    ref: React.Ref<HTMLInputElement>
  ) => <input data-1p-ignore {...props} ref={ref} />
);
